import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
    return (
        <div className="App">
            <header className="GlobalHeader_globalHeader__KVED3  ">
                <div className="GlobalHeader_container__Ab70T">
                    <div className="GlobalHeader_primaryNavigation__fsQzk"><a className="GlobalHeader_logo__0Wu9o"
                        href="index.html">IoT AI</a>
                        <nav className="GlobalHeader_primaryNav__FHTbN">
                            <ol className="GlobalHeader_primaryNavList__UFJ1n">
                                <li className=""><a href="https://iot-ai.gitbook.io/iot-ai-docs">Docs<span
                                    className="GlobalHeader_navDrawerArrow__uuQnp "></span></a></li>
                                <li className=""><a
                                    href="#">Buy
                                    $IoT<span className="GlobalHeader_navDrawerArrow__uuQnp "></span></a></li>
                            </ol>
                            <ol className="GlobalHeader_mobileExtras__NamJB">
                                <li>
                                    <ul className="GlobalHeader_headerSocials__Vzjuj">
                                        <li><a href="https://x.com/IoTai_ABB" title="Follow us on X" target="_blank"
                                            rel="noreferrer"><svg viewBox="0 0 32 32">
                                                <path
                                                    d="M18.8,13.7l11-12.8h-2.6L17.7,12L10,0.9H1.2l11.5,16.8L1.2,31.1h2.6l10.1-11.7L22,31.1h8.8L18.8,13.7L18.8,13.7  z M15.2,17.8l-1.2-1.7L4.8,2.8h4l7.5,10.7l1.2,1.7l9.8,14h-4L15.2,17.8L15.2,17.8z">
                                                </path>
                                            </svg></a></li>
                                        <li><a href="https://t.me/IoTAIportal" title="Join our Telegram" target="_blank"
                                            rel="noreferrer"><svg viewBox="0 0 32 32">
                                                <path
                                                    d="M16,0C7.2,0,0,7.2,0,16s7.1,15.9,15.9,15.9,15.9-7.1,15.9-15.9S24.8,0,16,0ZM23.4,10.9c-.2,2.5-1.3,8.6-1.8,11.4-.2,1.2-.7,1.6-1.1,1.6-.9,0-1.6-.6-2.5-1.2-1.4-.9-2.2-1.5-3.6-2.4-1.6-1-.6-1.6.3-2.5.2-.2,4.3-3.9,4.4-4.3,0,0,0-.2,0-.3,0,0-.2,0-.3,0-.1,0-2.4,1.5-6.7,4.4-.6.4-1.2.6-1.7.6-.6,0-1.7-.3-2.5-.6-1-.3-1.8-.5-1.7-1,0-.3.4-.6,1.2-.9,4.6-2,7.7-3.4,9.3-4,4.4-1.8,5.3-2.2,5.9-2.2.1,0,.4,0,.6.2.2.1.2.3.2.4,0,.1,0,.4,0,.6Z">
                                                </path>
                                            </svg></a></li>
                                    </ul>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="GlobalHeader_secondaryNavigation__Hgf7u">
                        <ul className="GlobalHeader_headerSocials__Vzjuj">
                            <li><a href="https://x.com/IoTai_ABB" title="Follow us on X" target="_blank"
                                rel="noreferrer"><svg viewBox="0 0 32 32">
                                    <path
                                        d="M18.8,13.7l11-12.8h-2.6L17.7,12L10,0.9H1.2l11.5,16.8L1.2,31.1h2.6l10.1-11.7L22,31.1h8.8L18.8,13.7L18.8,13.7  z M15.2,17.8l-1.2-1.7L4.8,2.8h4l7.5,10.7l1.2,1.7l9.8,14h-4L15.2,17.8L15.2,17.8z">
                                    </path>
                                </svg></a></li>
                            <li><a href="https://t.me/IoTAIportal
" title="Join our Telegram" target="_blank"
                                rel="noreferrer"><svg viewBox="0 0 32 32">
                                    <path
                                        d="M16,0C7.2,0,0,7.2,0,16s7.1,15.9,15.9,15.9,15.9-7.1,15.9-15.9S24.8,0,16,0ZM23.4,10.9c-.2,2.5-1.3,8.6-1.8,11.4-.2,1.2-.7,1.6-1.1,1.6-.9,0-1.6-.6-2.5-1.2-1.4-.9-2.2-1.5-3.6-2.4-1.6-1-.6-1.6.3-2.5.2-.2,4.3-3.9,4.4-4.3,0,0,0-.2,0-.3,0,0-.2,0-.3,0-.1,0-2.4,1.5-6.7,4.4-.6.4-1.2.6-1.7.6-.6,0-1.7-.3-2.5-.6-1-.3-1.8-.5-1.7-1,0-.3.4-.6,1.2-.9,4.6-2,7.7-3.4,9.3-4,4.4-1.8,5.3-2.2,5.9-2.2.1,0,.4,0,.6.2.2.1.2.3.2.4,0,.1,0,.4,0,.6Z">
                                    </path>
                                </svg></a></li>
                        </ul>
                    </div>
                    <div className="GlobalHeader_mobileToggle__dbDm_"><button><svg xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-menu">
                        <line x1="4" x2="20" y1="12" y2="12"></line>
                        <line x1="4" x2="20" y1="6" y2="6"></line>
                        <line x1="4" x2="20" y1="18" y2="18"></line>
                    </svg></button></div>
                </div>
            </header>
            <main className="page_page__FsKkS">
                <div className="Masthead_mastheadWrap__eBzY7">
                    <div className="Masthead_container__9CE60">
                        <div className="Masthead_mastheadContent__p8B9U">
                            <p>IoT AI
                            </p>
                            <h1> 
                            The AI Agent for IoT</h1>
                        </div>
                        <div className="Masthead_mastheadImage__RGKtL"><img alt="AI Agents for Good!" loading="lazy" width="1267"
                            height="1009" decoding="async" data-nimg="1"
                            src="./images/as.png" />
                            <p className="Masthead_mastheadSocials__MRRxg"><a href="https://t.me/IoTAIportal
"
                                className="Masthead_mastheadBtn__tfy4s"><img alt="AI Agents for Freedom!" loading="lazy"
                                    width="197" height="94" decoding="async" data-nimg="1"
                                    src="./images/telegramStats.f985d269.png" /></a><a
                                        href="#" className="Masthead_mastheadBtn__tfy4s"><img
                                        alt="AI Agents for Freedom!" loading="lazy" width="196" height="96" decoding="async"
                                        data-nimg="1"
                                        src="./images/twitterStats.d02f9a56.png" /></a></p>
                        </div>
                    </div>
                </div>
                <div className="Airdrop_airdropWrap___iQw6">
                    <div className="Airdrop_container__Bf8kI">
                        <div className="Airdrop_airdropImg__QwLz_"><iframe src="https://www.youtube.com/embed/AyXGA6KZ2H4?si=x3SaL6LIB5bzjSyw"
                            title="YouTube video player" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"></iframe></div>
                        <div className="Airdrop_airdropContent__0lch1">
                            <h2>$IOT is live 24/7</h2>
                            <h3>Watch US ON X. @IoTai_ABB WE'll REPLY IN REAL TIME</h3>
                            <p className="Airdrop_footnote__PTKyH">*She a bit cray.</p>
                        </div>
                    </div>
                </div>
                <div className="PlayerSkills_playerSkillsWrap__jPNVY">
                    <div className="PlayerSkills_container__Q9clj">
                        <div className="PlayerSkills_playerSkillsImg__rlT2q"><img alt="bah" loading="lazy" width="1280" height="704"
                            decoding="async" data-nimg="1"
                            src="./images/token.jpg" /></div>
                    </div>
                </div>
            </main>
            <footer className="GlobalFooter_globalFooter__uHCxe">
                <div className="GlobalFooter_container__1D8eU">
                    <div className="GlobalFooter_branding__4ixtd">
                        <ul className="GlobalFooter_footerSocials__KibIh">
                            <li><a href="https://x.com/IoTai_ABB" title="Follow us on X" target="_blank"
                                rel="noreferrer"><svg viewBox="0 0 32 32">
                                    <path
                                        d="M18.8,13.7l11-12.8h-2.6L17.7,12L10,0.9H1.2l11.5,16.8L1.2,31.1h2.6l10.1-11.7L22,31.1h8.8L18.8,13.7L18.8,13.7  z M15.2,17.8l-1.2-1.7L4.8,2.8h4l7.5,10.7l1.2,1.7l9.8,14h-4L15.2,17.8L15.2,17.8z">
                                    </path>
                                </svg></a></li>
                            <li><a href="https://t.me/IoTAIportal
" title="Join our Telegram" target="_blank"
                                rel="noreferrer"><svg viewBox="0 0 32 32">
                                    <path
                                        d="M16,0C7.2,0,0,7.2,0,16s7.1,15.9,15.9,15.9,15.9-7.1,15.9-15.9S24.8,0,16,0ZM23.4,10.9c-.2,2.5-1.3,8.6-1.8,11.4-.2,1.2-.7,1.6-1.1,1.6-.9,0-1.6-.6-2.5-1.2-1.4-.9-2.2-1.5-3.6-2.4-1.6-1-.6-1.6.3-2.5.2-.2,4.3-3.9,4.4-4.3,0,0,0-.2,0-.3,0,0-.2,0-.3,0-.1,0-2.4,1.5-6.7,4.4-.6.4-1.2.6-1.7.6-.6,0-1.7-.3-2.5-.6-1-.3-1.8-.5-1.7-1,0-.3.4-.6,1.2-.9,4.6-2,7.7-3.4,9.3-4,4.4-1.8,5.3-2.2,5.9-2.2.1,0,.4,0,.6.2.2.1.2.3.2.4,0,.1,0,.4,0,.6Z">
                                    </path>
                                </svg></a></li>
                        </ul>
                    </div>
                    <div className="GlobalFooter_copyright__A8soF">
                        <ol className="GlobalFooter_legalLinks__OIHrL">
                            <li><a title="Terms of Service" href="terms.html">Terms of Service</a></li>
                            <li><a title="Privacy &amp; Cookie Policy" href="privacy-cookie-policy.html">Privacy &amp; Cookie
                                Policy</a></li>
                        </ol>
                        <p>Copyright © 2025 UwU Collective Inc. All rights reserved</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default App;
